export default {
  EXCLUSIVE_TRUCK: 1, // Somente por caminhao
  STANDARD_SHIPPING: 2 // frete padrao (caminha, carro, etc)
};